/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CreateContractReviewerRequest = {
  properties: {
    cpf: {
      type: 'string',
      isRequired: true,
    },
    email: {
      type: 'string',
      isRequired: true,
    },
    role: {
      type: 'string',
      isRequired: true,
    },
    userId: {
      type: 'string',
    },
    approvalCompetencyId: {
      type: 'string',
    },
    type: {
      type: 'ContractReviewerType',
    },
  },
} as const;
